module.exports = __webpack_public_path__ + "img/MOH_logo.c29ce52c.png";